import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as style from "./styles.module.scss";
import { postExposureBasedMemoryTest } from "../../redux/actions/psychometricTestsActions";
import ProgressBar from "../../common/ProgressBar";
import history from "../../history";

const ExposureBased = ({ appData, postExposureBasedMemoryTestFunc }) => {
  const name = `${appData.firstName} ${appData.lastName}`;
  const questions = [...new Array(75)].map(
    (value, index) =>
      `https://hrgo.spacebetween.co.uk/images/exposureBasedMemoryTest/${
        index + 1
      }`
  );
  const optionsList = {
    option1: "Seen",
    option2: "New",
  };
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswer] = useState({});
  const [chosen, setChosen] = useState("");
  const [progress, setProgress] = useState(0);
  const progressCalculation = Math.round(
    (currentQuestion / questions.length) * 100
  );
  const updateProgress = () => {
    setProgress(progressCalculation);
  };
  const nextQuestion = () => {
    const next = answers[currentQuestion + 1];
    setCurrentQuestion(currentQuestion + 1);
    setChosen(next || "");
    updateProgress();
  };
  const previousQuestion = () => {
    const previous = answers[currentQuestion - 1];
    setCurrentQuestion(currentQuestion - 1);
    setChosen(previous || "");
    updateProgress();
  };
  const storeAnswer = (questionNumber, chosenAnswer) => {
    setChosen(chosenAnswer);
    setAnswer({ ...answers, [questionNumber - 1]: chosenAnswer });
  };
  const loadChosen = () => {
    const answerScale = answers[currentQuestion - 1];
    setChosen(answerScale);
  };
  const handleOptionButton = (e) => {
    storeAnswer(currentQuestion + 1, e.target.value);
    if (currentQuestion !== questions.length - 1) {
      setTimeout(() => {
        nextQuestion();
      }, 800);
    }
  };
  const submitTest = () => {
    postExposureBasedMemoryTestFunc(answers, name);
    history.push("/profile/MyTests/results", {
      testName: "exposureBasedMemory",
      pdfName: "Exposure_Based_Memory_Test_Feedback_Fields.pdf",
    });
  };
  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div style={{ padding: "5%" }} className="col-sm-9 col-lg-8">
        <div className={style.mainSection}>
          <h2>Exposure Based Memory Test</h2>
          {ProgressBar(progressCalculation)}
        </div>
        <div>
          <section className="section-body p-1">
            <p className="mb-2">
              Please select &quot;Seen&quot; if you have already seen the person
              or select &quot;New&quot; if you have not yet.
            </p>
            <article>
              <div className={style.mainContainer}>
                <h4 className={style.legendContainer}>
                  <div className={style.question}>
                    Question {currentQuestion + 1} / {questions.length}
                  </div>
                  <img
                    src={`${questions[currentQuestion]}.jpg`}
                    style={{ width: "180px", height: "210px" }}
                  />
                </h4>
                <div className={style.optionsContainer}>
                   {" "}
                  <label
                    onClick={(event) => handleOptionButton(event)}
                    className={style.optionChoice}
                  >
                     {" "}
                    <input
                      style={{ marginRight: "5px" }}
                      checked={chosen === optionsList.option1}
                      type="radio"
                      id="html"
                      value={optionsList.option1}
                    />
                    {optionsList.option1}
                  </label>
                  <label
                    onClick={(event) => handleOptionButton(event)}
                    className={style.optionChoice}
                  >
                     {" "}
                    <input
                      style={{ marginRight: "5px" }}
                      checked={chosen === optionsList.option2}
                      type="radio"
                      id="html"
                      value={optionsList.option2}
                    />
                    {optionsList.option2}
                  </label>
                </div>
              </div>
            </article>
            <div className={style.testButtons}>
              {questions[currentQuestion] === questions[0] ? (
                <button
                  className="btn btn-outline-dark text-orange col-12 col-sm-3 col-lg-2 my-2"
                  onClick={() => history.push("/profile/MyTests")}
                >
                  Cancel
                </button>
              ) : (
                <button
                  onClick={() => {
                    loadChosen();
                    previousQuestion();
                  }}
                  style={{ minWidth: "fit-content" }}
                  className="btn btn-outline-dark text-orange col-12 col-sm-3 col-lg-2 my-2"
                >
                  Change previous answer
                </button>
              )}
              {currentQuestion === questions.length - 1 && (
                <button
                  disabled={!chosen || chosen === ""}
                  onClick={submitTest}
                  id="btnBasicInfoEditSubmit"
                  className="btn btn-primary col-12 col-sm-3 col-lg-2 my-2"
                >
                  Finish
                </button>
              )}
            </div>
            <div className="d-flex justify-content-end">
              <Link
                to="/profile/MyTests"
                className="btn btn-outline-dark text-dark col-12 col-sm-3 col-lg-2 my-2 hover-text-white"
              >
                My Tests
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
const mapDispatchToProps = {
  postExposureBasedMemoryTestFunc: postExposureBasedMemoryTest,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(ExposureBased);
